export function useOnClick(props) {
  return function save() {
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
